import { render } from "./TableFooter.vue?vue&type=template&id=7b8e563a&ts=true"
import script from "./TableFooter.vue?vue&type=script&lang=ts"
export * from "./TableFooter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__